var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "container" },
    [
      _c("top", {
        attrs: { currentComponent: _vm.currentComponent, topList: _vm.topList },
        on: { Select: _vm.Select },
      }),
      _c(_vm.currentComponent, { tag: "component" }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }